import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body d-flex flex-column" }
const _hoisted_2 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "text-dark text-hover-primary fw-bolder fs-3"
}, "Earnings", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "pt-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-dark fw-bolder fs-2x lh-0" }, "$"),
  /*#__PURE__*/_createVNode("span", { class: "text-dark fw-bolder fs-3x me-2 lh-0" }, "560"),
  /*#__PURE__*/_createVNode("span", { class: "text-dark fw-bolder fs-6 lh-0" }, "+ 28% this week")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"],
    style: `background-color: ${_ctx.widgetColor}`
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_apexchart, {
          class: "mixed-widget-13-chart",
          options: _ctx.chartOptions,
          series: _ctx.series,
          height: _ctx.chartHeight,
          type: "area"
        }, null, 8, ["options", "series", "height"])
      ]),
      _hoisted_4
    ])
  ], 6))
}